import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';

interface SectionWrapperProps {
  children?: React.ReactNode;
  className?: string;
  innerClassName?: string;
  maxWidth?: string;
  id?: string;
}

const SectionWrapper = forwardRef<HTMLElement, SectionWrapperProps>(
  ({ children, className = '', innerClassName = '', maxWidth = 'max-w-[1440px]', id }, ref) => {
    return (
      <section 
        ref={ref} 
        id={id}
        className={cn('h-auto w-screen flex items-center justify-center relative', className)}
      >
        <div className={cn('h-full w-full', maxWidth, 'flex items-center justify-center', innerClassName)}>
          {children}
        </div>
      </section>
    );
  }
);

SectionWrapper.displayName = 'SectionWrapper';

export default SectionWrapper;